import { ISTVMDigital } from '@hub-workspace/apps/logged-home/src/app/shared/interfaces/stvm-digital.interface';
import { STVMDigitalAction } from './stvm-digital.action';

export interface STVMDigitalState {
  portabilities: Array<ISTVMDigital>;
  portabilityAcceptStatus: string;
  pending: boolean;
  isLoaded: boolean;
  portabilitiesError: string;
  showPortabilityErrorModal: boolean;
  showPortabilityAcceptModal: boolean;
  showPortabilityDeclineModal: boolean;
}

export const initialState: STVMDigitalState = {
  portabilities: null,
  portabilityAcceptStatus: null,
  pending: false,
  isLoaded: false,
  portabilitiesError: null,
  showPortabilityErrorModal: false,
  showPortabilityAcceptModal: false,
  showPortabilityDeclineModal: false
};

export function STVMDigitalReducer(
  state: STVMDigitalState = initialState,
  action?: STVMDigitalAction
): STVMDigitalState {
  switch (action.type) {
    case STVMDigitalAction.getPortabilities:
    case STVMDigitalAction.acceptPortability: {
      return {
        ...state,
        ...{ pending: true }
      };
    }

    case STVMDigitalAction.getPortabilitiesSuccess: {
      const portabilities = action.payload as Array<ISTVMDigital>;

      return {
        ...state,
        ...{
          pending: false,
          isLoaded: true,
          showPortabilityErrorModal: false,
          portabilities: portabilities
        }
      };
    }

    case STVMDigitalAction.getPortabilitiesError:
      return {
        ...state,
        ...{
          pending: false,
          isLoaded: true,
          showPortabilityErrorModal: true,
          portabilitiesError: action.payload
        }
      };

    case STVMDigitalAction.acceptPortabilitySuccess: {
      const portabilityAcceptStatus = action.payload;

      return {
        ...state,
        ...{
          pending: false,
          isLoaded: true,
          portabilities: portabilityAcceptStatus.action.portabilities.filter(
            portability => {
              return (
                portability.id !== portabilityAcceptStatus.action.payload.id
              );
            }
          ),
          showPortabilityErrorModal: false,
          showPortabilityAcceptModal:
            portabilityAcceptStatus.action.payload.accepted,
          showPortabilityDeclineModal: !portabilityAcceptStatus.action.payload
            .accepted
        }
      };
    }

    case STVMDigitalAction.acceptPortabilityError:
      return {
        ...state,
        ...{
          pending: false,
          isLoaded: true,
          showPortabilityErrorModal: true
        }
      };

    default:
      return state;
  }
}
